module.exports = __webpack_public_path__ + "static/media/scheduler_text_lto.f44a67d7.xlsx";